// ======================================================================
// File Name       : ReceivedMessageListContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, isInvalid, getFormValues } from 'redux-form';
import moment from 'moment';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import ReceivedMessageSearch from '../../components/messageThread/ReceivedMessageSearch';
import ReceivedMessageList from '../../components/messageThread/ReceivedMessageList';
import * as MessageThreadAction from '../../actions/MessageThreadAction';
import { RETURN_MAX_NUM, DEFAULT_DATE_FORMAT_SERVER } from '../../constants/index';
import { MESSAGE_TYPE, MESSAGE_FILTER } from '../../constants/MessageThreadContants';
import { RECEIVED_MESSAGE_LIST, RECEIVE_CHAT_DETAIL } from '../../constants/PathConstants';
import * as actionType from '../../constants/actionTypes/page';

class ReceivedMessageListContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      messageSortType: 8,
      startPosition: 0,
      ascendingDescendingSort: 0,
      isAllowShowSearchMessage: false,
    };
    this.initData = this.initData.bind(this);
    this.createParams = this.createParams.bind(this);
    this.searchData = this.searchData.bind(this);
    this.onSearchBtnClick = this.onSearchBtnClick.bind(this);
    this.downloadAttachment = this.downloadAttachment.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.goToDetail = this.goToDetail.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentWillMount() {
    this.initData();
  }

  goToDetail(rootMessageIdAuto, authorSecernId) {
    const { invalid, formValues } = this.props;
    if (!invalid) {
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION,
        parentPath: RECEIVED_MESSAGE_LIST,
        searchCondition: formValues,
      });
    }
    const path = RECEIVE_CHAT_DETAIL.replace(':messageRootId', rootMessageIdAuto).replace(
      ':userSecernId',
      authorSecernId,
    );
    this.props.history.push(path);
  }

  componentWillUnmount() {
    const { invalid, formValues } = this.props;
    if (!invalid) {
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION,
        parentPath: RECEIVED_MESSAGE_LIST,
        searchCondition: formValues,
      });
    }
  }

  initData() {
    const { initialValues } = this.props;
    let column = null;
    let startPosition = 0;
    if (initialValues) {
      if (initialValues.messageSortType) {
        column = initialValues.messageSortType;
      }
      if (initialValues.startPosition) {
        startPosition = initialValues.startPosition;
      }
    }
    const param = this.createParams(initialValues, startPosition, column);
    this.props.dispatch(MessageThreadAction.getReceivedMessageList(param));
  }

  searchData(startPosition, column) {
    const { formValues, invalid } = this.props;
    if (invalid) {
      return;
    }
    const param = this.createParams(formValues, startPosition, column);
    this.props.dispatch(MessageThreadAction.getReceivedMessageList(param)).then(() => {
      this.setState({ isAllowShowSearchMessage: true });
    });
  }

  onSearchBtnClick() {
    const { invalid } = this.props;
    if (invalid) return;
    this.props.change('startPosition', 0);
    this.searchData(0);
  }

  downloadAttachment(item) {
    if (item && Object.keys(item).length) {
      if (isNaN(parseInt(item.messageType, 10)) || !item.messageIdAuto) {
        return;
      }
      const param = {};
      param.messageType = item.messageType;
      param.messageIdAuto = item.messageIdAuto;
      this.props.dispatch(MessageThreadAction.downloadMessageAttachment(param));
    }
  }

  createParams(searchInfo, startPosition, column) {
    const param = {};
    param.messageType = MESSAGE_TYPE.SUB;
    const paramSearchInfo = {};
    paramSearchInfo.messageSortType = this.state.messageSortType;
    paramSearchInfo.sentReceivedMessageFilter = MESSAGE_FILTER.RECEIVED;
    if (searchInfo && Object.keys(searchInfo).length) {
      searchInfo.messageTitle && (paramSearchInfo.messageTitle = searchInfo.messageTitle);
      searchInfo.authorName && (paramSearchInfo.authorName = searchInfo.authorName);
      searchInfo.sentDateFrom &&
        (paramSearchInfo.sentDateFrom = moment(searchInfo.sentDateFrom)
          .startOf('day')
          .format(DEFAULT_DATE_FORMAT_SERVER));
      searchInfo.sentDateTo &&
        (paramSearchInfo.sentDateTo = moment(searchInfo.sentDateTo)
          .endOf('day')
          .format(DEFAULT_DATE_FORMAT_SERVER));
      paramSearchInfo.startPosition = (searchInfo.startPosition || 0);
    }
    if (!isNaN(parseInt(startPosition, 10))) {
      paramSearchInfo.startPosition = startPosition;
    }
    if (column && Object.keys(column).length) {
      paramSearchInfo.ascendingDescendingSort = column.sortState;
      paramSearchInfo.messageSortType = column.sortBy;
    }
    paramSearchInfo.returnMaxNum = RETURN_MAX_NUM;
    param.searchInfo = paramSearchInfo;
    return param;
  }

  getStartEndData(startPosition) {
    const { invalid } = this.props;
    if (invalid) return;
    this.searchData(startPosition);
  }

  handleSortState(column) {
    const { invalid } = this.props;
    if (invalid) return;
    this.searchData(null, column);
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  render() {
    const { receiveMessages, recordNum, startPosition, invalid } = this.props;
    const { hoverIndex } = this.state;
    return (
      <div>
        <MessageSearch
          recordNum={recordNum}
          resultList={receiveMessages ? receiveMessages.allMessageIds : []}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <h3>検索する項目を指定してください</h3>
        <ReceivedMessageSearch
          onSearchBtnClick={this.onSearchBtnClick}
          startPosition={startPosition}
          invalid={invalid}
        />
        <ReceivedMessageList
          receiveMessages={receiveMessages}
          downloadAttachment={this.downloadAttachment}
          getStartEndData={this.getStartEndData}
          recordNum={recordNum}
          startPosition={startPosition}
          invalid={invalid}
          handleSortState={this.handleSortState}
          goToDetail={this.goToDetail}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          hoverIndex={hoverIndex}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { receivedMessageListSearchForm } = state.form;
  const { receiveMessages, recordNum } = state.messageThread;
  const { parentPath, searchCondition } = state.page;
  let initial = {};
  if (parentPath === RECEIVED_MESSAGE_LIST) {
    initial = searchCondition;
  }
  return {
    receiveMessages,
    recordNum,
    receivedMessageListSearchForm,
    invalid: isInvalid('receivedMessageListSearchForm')(state),
    formValues: getFormValues('receivedMessageListSearchForm')(state),
    initialValues: initial,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'receivedMessageListSearchForm',
    touchOnChange: true,
  })(ReceivedMessageListContainer),
);
